import 'react-datepicker/dist/react-datepicker.css';

import PropTypes from 'prop-types';
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { Controller, useFormContext } from 'react-hook-form';

import TextField from './TextField';

const DatePicker = ({ name, defaultValue, required, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <ReactDatePicker
          selected={field.value}
          onChange={(date) => field.onChange(date)}
          {...rest}
          customInput={<TextField prefix="calendar" suffix="dropdown" />}
        />
      )}
    />
  );
};

DatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  required: PropTypes.bool,
};

DatePicker.defaultProps = {
  defaultValue: '',
  required: false,
};

export default DatePicker;
